<template>
  <table class="pt-receiving-message">
    <pt-form-list-item label="收货人姓名：" :required="true" >
        <wt-input class="receiving-name" v-model="crrentValue.contactName" data-vv-as="收货人姓名" name="name" v-validate="'required'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="收货人电话：" :required="true">
        <wt-input  class="receiving-name" v-model="crrentValue.phone" data-vv-as="收货人电话" name="name" v-validate="'required'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="收货人地址：" :required="true">
        <pt-address-select v-model="crrentValue.address" required clearable @change="change"  data-vv-as="收货人地址" name="name" v-validate="'required'" ref="address"></pt-address-select>
    </pt-form-list-item>
  </table>
</template>

<script>

import ptAddressSelect from 'cps/base/pt-address-select/withData'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-receiving-message'
export default {
  name: 'pt-receiving-message',
  mixins: [formMixins],
  components: {
    ptAddressSelect
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    addressForm () {
      return this.$refs.address
    }
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    address: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      crrentValue: this.address
    }
  },
  watch: {
    address: {
      handler: function (val) {
        this.crrentValue = JSON.parse(JSON.stringify(val))
        let { provinceGbCode, cityGbCode, districtGbCode, postAddress } = val
        this.crrentValue.address = { provinceGbCode, cityGbCode, districtGbCode, postAddress }
      }
    },
    crrentValue: {
      handler: function (val) {
        let data = { ...val, ...val.address }
        delete data.address
        this.$emit('input', data)
      },
      deep: true
    }
  },
  methods: {
    change (val) {
      let data = { ...this.crrentValue, ...val }
      delete data.address
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-receiving-message{
    padding: 0 20px;
    display: contents;
    .receiving-name{
    width: 200px
    }
}
</style>
